import { articelsHomePageImages } from "../../services/images.service"
import { GreyBorderBottom } from "../ui/elements"

export function AnimeCharacterMobile({anime}) {
    return (
        <div>
                 {/* ✅ הצגת דמויות */}
                 {anime.characters && anime.characters.length > 0 && (
                   <div className="">
                     {/* 🔹 כותרת */}
                     <div className="mb-4">
                       <h5>דמויות ומדבבים</h5>
                <GreyBorderBottom className="w-full" />
                     </div>
           
                     {/* 🔹 טבלה עם דמויות ומדובבים */}
                     <div className="flex flex-col gap-4">
                       {anime.characters.map((character, index) => {
                         // ✅ מחשב מספר השורה לפי מספר העמודות (2)
                         const rowIndex = Math.floor(index / 1)
                         const bgColor =
                           rowIndex % 2 === 0 ? 'bg-[#363636]' : 'bg-[#1F1F1F]'
           
                         return (
                           <div
                             key={character.character_mal_id || index}
                             className={`flex items-center gap-4 ${bgColor} truncate`}
                           >
                             {/* 🔹 תמונת הדמות */}
                             <img
                               src={
                                 character.images?.image_url ||
                                 'https://placehold.co/150X180'
                               }
                               alt={character.name}
                               className="w-10 h-16 object-cover"
                             />
           
                             {/* 🔹 פרטי הדמות */}
                             <div className="flex-1 truncate">
                               <p className="text-lg font-bold text-softText truncate">
                                 {character.name.length > 8 ? character.name.slice(0, 8) + '...' : character.name}
                               </p>
                               <p className="text-gray-400 text-sm truncate">
                                 {character.role}
                               </p>
                             </div>
           
                             {/* 🔹 פרטי המדובב */}
                             {character.voice_actors?.length > 0 && (
                               <div className="flex gap-2 items-center truncate">
                                 <div className="flex flex-col items-end truncate">
                                   <p className="text-lg font-bold text-softText truncate">
                                     {character.voice_actors[0].name.length > 8 ? character.voice_actors[0].name.slice(0, 8) + '...' : character.voice_actors[0].name}
                                   </p>
                                   <p className="text-gray-400 text-xs truncate">
                                     {character.voice_actors[0].language}
                                   </p>
                                 </div>
           
                                 {/* 🔹 תמונת המדובב */}
                                 <img
                                   src={character.voice_actors[0].image}
                                   alt={character.voice_actors[0].name}
                                   className="w-10 h-16 object-cover mt-1"
                                 />
                               </div>
                             )}
                           </div>
                         )
                       })}
                     </div>
                   </div>
                 )}
        </div>
    )
}